module.exports = __webpack_public_path__ + "assets/img/logo.fc9a38f2.svg";